import type { Lang } from "@noli/core";

import { injectScope } from "@/utils/lang/util";
import { wenxinLangRecords } from "./wenxin/lang";
import { draftLangRecords, draftModelRecords } from "./draft/lang";
import { monkeyLangRecords } from "./monkey/lang";

export enum Third_Party_Words {
  "wenxin" = "wenxin",
  "no-import-warning" = "no-import-warning",
  "draft" = "draft",
  "monkey" = "monkey",
  "third-party" = "third-party",
}

injectScope("thirdParty", Third_Party_Words);

export const thirdPartyLangRecords: Record<Lang, Record<Third_Party_Words, string>> = {
  zh: {
    [Third_Party_Words["wenxin"]]: "百度文心",
    [Third_Party_Words["no-import-warning"]]:
      "使用第三方模型生成图像需要消耗画力星，通过参数生成可能不太划算哦~ 😉",
    [Third_Party_Words["draft"]]: "Draft",
    [Third_Party_Words["monkey"]]: "社区大模型",
    [Third_Party_Words["third-party"]]: "第三方模型",
  },
  en: {
    [Third_Party_Words["wenxin"]]: "Baidu Wenxin",
    [Third_Party_Words["no-import-warning"]]:
      "We need 'Credits' to generate images with third-party-models, so it might not worth generating from parameters! 😉",
    [Third_Party_Words["draft"]]: "Draft",
    [Third_Party_Words["monkey"]]: "社区大模型",
    [Third_Party_Words["third-party"]]: "Third Party Model",
  },
};

export const allThirdPartyLangRecords = [
  thirdPartyLangRecords,
  wenxinLangRecords,
  draftLangRecords,
  draftModelRecords,
  monkeyLangRecords,
];
